// Simple helpers to use CSS variables across inline styles
export const primary = 'var(--primary-color)';
export const secondary = 'var(--secondary-color)';
export const accent = 'var(--accent-color)';
export const gradientPrimarySecondary = 'linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%)';
